export const themeOptionFactory = (theme) => ({
  mixins: {
    drawerBleeding: { height: 200 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ".maptalks-canvas-layer": {
          backgroundColor: theme.palette.common.white,
        },
        ".is-rtl": {
          "& .MuiSvgIcon-root": {
            transform: "rotate(180deg) !important",
          },
        },
      },
    },
    LuxuryPage: {
      styleOverrides: {
        root: {},
        emptyDataContainer: {
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: theme.spacing(3),
          marginTop: "calc(50vh - 116px - 64px)", //50vh - emptydata height - header height,
        },
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(166px, 1fr))",
          justifyItems: "center",
          gap: theme.spacing(1),
        },
        luxuryCard: {
          width: "100%",
        },
      },
    },
    AttractionCard: {
      styleOverrides: {
        root: {
          width: 343,
          height: 203,
          borderRadius: "12px",
          position: "relative",
          boxShadow: "none",
          "&:before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            width: 343,
            height: 203,
            background:
              "linear-gradient(180deg,rgba(0,0,0,0.1) 32.72%, rgba(0,0,0,0.70) 61.96%)",
            borderRadius: "12px",
          },
          "[dir='rtl'] &:before": {
            background:
              "linear-gradient(180deg,rgba(0,0,0,0.1) 67.28%, rgba(0,0,0,0.70) 61.96%)",
          },
        },
        cardMedia: { height: "100%" },
        cardContent: {
          height: "88px",
          padding: theme.spacing(0, 1.5, 1.5),
          position: "absolute",
          bottom: 0,
          "&:last-child": {
            paddingBottom: theme.spacing(1.5),
          },
        },
        titleText: {
          fontSize: "1rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          marginBottom: theme.spacing(0.5),
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
        },
        descriptionText: {
          fontSize: "0.875rem",
          color: theme.palette.primary.contrastText,
          width: 287,
          height: 52,
          borderLeft: `4px solid ${theme.palette.primary.main}`,
          lineHeight: 1.2,
          paddingLeft: theme.spacing(1),
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
        },
        button: {
          background: theme.palette.primary.main,
          position: "absolute",
          width: 32,
          height: 32,
          minWidth: 32,
          bottom: "12px",
          right: "12px",
          borderRadius: "100px",
          "& .MuiSvgIcon-root": {
            width: "16px",
            height: "16px",
            fill: theme.palette.primary.contrastText,
          },
          "&:hover": {
            background: theme.palette.primary.main,
          },
        },
      },
    },
    AttractionPage: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
          flexDirection: "column",
        },
      },
    },
    VuiSearchPopupContent: {
      styleOverrides: {
        root: {
          display: "grid",
          padding: theme.spacing(2, 1.5, 0),
          width: "auto",
          gap: theme.spacing(1, 1.5),
          alignItems: "center",
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          gridTemplateAreas:
            "'backButton search' \n 'venueSelector venueSelector'",
          gridTemplateColumns: "24px 1fr",
          gridTemplateRows: "44px 37px",
          [theme.breakpoints.up("md")]: {
            padding: theme.spacing(2, 1.5, 0),
          },
        },
        closeButton: {
          padding: 0,
          width: "32px",
          height: "32px",
          gridArea: "backButton",
          color: theme.palette.text.secondary,
          [theme.breakpoints.up("md")]: {
            display: "block",
          },
        },
        closeButtonIcon: {
          color: "inherit",
        },
        searchInput: {
          gridArea: "search",
          background:
            "linear-gradient(white, white) padding-box,linear-gradient(to left top, #C8AF55, #EEE7CC) border-box",
          borderRadius: 9999,
          padding: theme.spacing(1.25, 2),
          fontSize: "1rem",
          gap: theme.spacing(2),
          fontWeight: 400,
          border: "1px solid transparent",
          "& input": {
            padding: 0,
          },
          "& .MuiSvgIcon-root": {
            fontSize: "1.125rem",
            color: "#C6C5C9",
          },
          "& .MuiInputAdornment-root": {
            "&.MuiInputAdornment-positionEnd": {
              "& .MuiSvgIcon-root": {
                width: 8,
                height: 8,
              },
            },
          },
          [theme.breakpoints.up("md")]: {
            width: "100%",
          },
        },
        suggestedList: {
          marginTop: theme.spacing(2),
        },
        venueFilterContainer: {
          display: "block",
          gridArea: "venueSelector",
          margin: theme.spacing(0, -1.5),
        },
      },
    },
    VuiAdSuggestList: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0),
          backgroundColor: theme.palette.background.paper,
          margin: theme.spacing(0, 2),
          borderRadius: "16px",
        },
        suggestTitle: {
          fontSize: "1rem",
          fontWeight: 700,
        },
        suggestList: {
          "& .splide__track": {
            padding: theme.spacing(2, 0),
          },
          "& .splide__pagination": {
            width: "fit-content",
            height: "4px",
            padding: 0,
            margin: "0 auto",
            background: "#E4E2E3",
            display: "flex",
            justifyContent: "center",
            gap: "0",
            borderRadius: "32px",
          },
          "& .splide__pagination li": {
            height: "4px",
            margin: "0",
            padding: "0",
          },
          "& .splide__pagination__page": {
            width: "30px",
            height: "4px",
            borderRadius: "10px",
            background: "#E4E2E3",
            display: "block",
            margin: 0,
          },
          "& .splide__pagination__page.is-active": {
            transform: "scale(1)",
            height: "4px",
            width: "30px",
            backgroundColor: theme.palette.primary.main,
            opacity: "1",
            display: "block",
            margin: 0,
          },
        },
        suggestListItem: {
          display: "flex",
          flexDirection: "column",
          padding: 0,
          justifyContent: "center",
        },
        suggestItemAvatar: {
          "& .MuiAvatar-root": {
            marginRight: 0,
          },
        },
        suggestItemContent: {
          marginTop: theme.spacing(0.5),
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            textAlign: "center",
            height: 36,
            fontWeight: 400,
            color: "#56464A",
          },
        },
      },
    },
    VuiSearchResult: {
      styleOverrides: {
        root: {
          flexGrow: 1,
          width: "100%",
          overflow: "hidden",
          [theme.breakpoints.up("md")]: {
            marginTop: 0,
            border: "none",
            borderRadius: "unset",
          },
        },
        rootDialog: {
          height: "300px",
        },
        list: {
          padding: theme.spacing(2.75, 0),
        },
        listItem: {
          padding: theme.spacing(1, 2),
        },
      },
    },
    VuiSearchResultItem: {
      defaultProps: {
        secondaryTextKeys: ["floorText"],
      },
      styleOverrides: {
        chip: {
          height: "18px",
          fontWeight: 400,
          backgroundColor: "#e2e2e4",
          color: theme.palette.text.primary,
          fontSize: "0.625rem",
          borderRadius: "24px",
          "& .MuiChip-label": {
            padding: theme.spacing(0.5, 1),
          },
        },
        primaryWrapper: {
          display: "flex",
          alignItems: "flex-start",
          gap: theme.spacing(0.75),
          flexDirection: "row-reverse",
          justifyContent: "flex-end",
        },
        chipContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(0.5),
        },
        newShopChip: {
          display: "flex",
          height: 16,
          padding: theme.spacing(0.25, 1),
          width: 50,
        },
        comingSoonChip: {
          display: "flex",
          height: 16,
          padding: theme.spacing(0.25, 1),
          width: 100,
        },
        vatRefundChip: {
          height: 16,
          "& .MuiChip-label": {
            fontSize: "0.6875rem",
          },
        },
      },
    },
    FeatureListItem: {
      defaultProps: {
        locationTextSeparator: " | ",
      },
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          padding: theme.spacing(1.5, 0),
          height: 78,
        },
        adornmentWrapper: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flex: "none",
        },
        adornmentMedia: {
          objectFit: "contain",
          maxWidth: "60px",
          maxHeight: "55px",
        },
        bottomDivider: {
          borderBottom: "1px solid rgba(203, 203, 203, 0.5)",
          marginLeft: 0,
          marginRight: 0,
        },
        listItemText: {
          margin: 0,
          flex: 2.5,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
          "& .MuiListItemText-primary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.2,
            fontSize: "0.875rem",
            fontWeight: 700,
            whiteSpace: "normal",
            wordBreak: "break-all",
          },
          "& .MuiListItemText-secondary": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            lineHeight: 1,
            whiteSpace: "normal",
            wordBreak: "break-all",
            fontSize: "0.75rem",
          },
        },
        listItemAvatar: {
          "& .MuiAvatar-root": {
            fontSize: "2.275rem",
            height: 54,
            width: 54,
            marginRight: theme.spacing(2),
            borderRadius: "8px",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
          "& .MuiAvatar-root .MuiAvatar-img": {
            objectFit: "cover",
          },
        },
        listItemContent: {
          display: "flex",
          width: "100%",
          gap: theme.spacing(2),
        },
        listItemWrapper: {
          display: "flex",
          gap: theme.spacing(0.5),
          flexDirection: "column",
          flexGrow: 1,
        },
        chipContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(0.5),
        },
        locationText: {
          lineHeight: 1,
          fontSize: "0.75rem",
        },
        floorTextAvatar: {
          width: 24,
          height: 24,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          minWidth: 24,
          borderRadius: "50%",
          display: "none",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "0.75rem",
        },
        sponsoredChip: {
          maxWidth: 32,
          width: 32,
          height: 20,
          fontSize: "0.6875rem",
          fontWeight: 400,
          display: "inline-flex",
          justifyContent: "center",
          marginRight: theme.spacing(0.5),
          "& .MuiChip-label": {
            overflow: "unset",
            color: theme.palette.text.primary,
            paddingLeft: theme.spacing(0.5),
            paddingRight: theme.spacing(0.5),
            fontSize: "0.6875rem",
          },
        },
        newShopChip: {
          height: 16,
          padding: theme.spacing(0.25, 1),
          width: 50,
          "& .MuiChip-label": {
            fontSize: "0.6875rem",
          },
        },
        comingSoonChip: {
          height: 16,
          padding: theme.spacing(0.25, 1),
          width: 100,
          "& .MuiChip-label": {
            fontSize: "0.6875rem",
          },
        },
        vatRefundChip: {
          height: 16,
          "& .MuiChip-label": {
            fontSize: "0.6875rem",
          },
        },
      },
    },
    VenueFilterBar: {
      styleOverrides: {
        root: {
          flexDirection: "row",
          display: "flex",
          gap: 0,
          height: 37,
          borderRadius: 0,
          overflow: "hidden",
          paddingRight: 0,
        },
        button: {
          flex: 1,
          justifyContent: "center",
          border: "none",
          borderRadius: 0,
          borderBottom: "1px solid #E2E2E4",
          padding: 0,
          paddingBottom: theme.spacing(0.25),
          fontSize: "1rem",
          "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            marginLeft: 0,
            borderLeft: "none",
            borderRadius: 0,
          },
          "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderRadius: 0,
          },
          "&.Mui-selected": {
            background: "transparent",
            color: theme.palette.primary.main,
            borderBottom: `3px solid ${theme.palette.primary.main}`,
            paddingBottom: 0,
            fontWeight: 700,
            "&:hover": {
              background: "transparent",
              color: theme.palette.primary.main,
              border: "none",
              borderBottom: `3px solid ${theme.palette.primary.main}`,
            },
          },
          "&:hover": {
            background: "transparent",
            color: theme.palette.primary.main,
            border: "none",
            borderBottom: `1px solid ${theme.palette.divider}`,
          },
          "&.ALL": {
            order: 1,
          },
          "&.ics": {
            order: 3,
          },
          "&.iconsiam": {
            order: 2,
          },
        },
        logoImage: {
          height: 28,
          marginTop: theme.spacing(0.25),
        },
      },
    },
    ServiceCard: {
      styleOverrides: {
        root: {
          display: "flex",
          position: "relative",
          height: 140,
          width: "auto",
          alignItems: "flex-end",
          background: theme.palette.background.paper,
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "none",
          "&:before": {
            display: "inline",
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            background: `linear-gradient(180deg, transparent 19.68%, ${theme.palette.background.paper} 61.96%)`,
          },
          "[dir='rtl'] &:before": {
            background: `linear-gradient(180deg, transparent 80.32%, ${theme.palette.background.paper} 61.96%)`,
          },
          "&:first-of-type": {
            borderRadius: "16px",
          },
          "&:last-of-type": {
            borderRadius: "16px",
          },
        },
        cardMedia: {
          width: "100%",
          height: "100%",
          borderRadius: "16px",
        },
        cardContentWrapper: {
          display: "flex",
          position: "absolute",
          justifyContent: "space-between",
          width: "100%",
          gap: theme.spacing(1.5),
          padding: theme.spacing(1.5),
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "end",
          flex: 1,
          gap: theme.spacing(1),
          padding: 0,
        },
        cardTitle: {
          fontStyle: "normal",
          fontWeight: 700,
          color: theme.palette.primary.main,
          lineHeight: "128%",
        },
        cardDescription: {
          fontStyle: "normal",
          lineHeight: "120%",
          color: theme.palette.text.secondary,
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "break-all",
        },
        arrowNextButton: {
          padding: 0,
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
            color: theme.palette.text.secondary,
          },
        },
      },
    },
    AppHeader: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
          borderBottom: "none",
        },
        toolbar: {
          minHeight: 64,
          padding: theme.spacing(0, 2),
          [theme.breakpoints.up("md")]: {
            maxWidth: 900,
            margin: "0 auto",
          },
        },
        backButtonContainer: {
          display: "inline-flex",
          position: "unset",
          color: theme.palette.text.secondary,
          "& .MuiButtonBase-root": {
            backgroundColor: "transparent",
            padding: theme.spacing(1),
            "& .MuiSvgIcon-root": {
              width: "24px",
              height: "24px",
            },
          },
          [theme.breakpoints.up("md")]: {
            display: "flex",
          },
        },
        titleContainer: {
          textAlign: "left",
          fontSize: "1rem",
          color: theme.palette.primary.main,
          fontWeight: 700,
          [theme.breakpoints.up("md")]: {
            display: "block",
          },
        },
        searchButtonContainer: {
          color: theme.palette.text.secondary,
          position: "absolute",
          right: "16px",
        },
        filterSection: {},
      },
    },
    AppHeaderSearchButton: {
      styleOverrides: {
        root: {
          background: "#F3F3F4",
          borderRadius: "9999px",
        },
        icon: {
          width: 20,
          height: 20,
        },
      },
    },
    AppHeaderBackButton: {
      styleOverrides: {
        root: {},
        icon: {},
      },
    },
    AppPageLayout: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
          minHeight: "calc(100vh - 70px)",
          paddingBottom: theme.spacing(13.75),
          [theme.breakpoints.up("md")]: {
            minHeight: "calc(100vh - 70px)",
            paddingBottom: theme.spacing(13.75),
            backgroundColor: theme.palette.background.paper,
          },
        },
        container: {
          padding: theme.spacing(1.5, 2),
          [theme.breakpoints.up("md")]: {
            position: "unset",
            width: "100%",
            maxWidth: "900px",
            marginLeft: "auto",
            marginRight: "auto",
            padding: theme.spacing(1.5, 3),
          },
        },
        headerWrapper: {
          position: "sticky",
          top: 0,
          zIndex: 2,
        },
        navigationContainer: {
          [theme.breakpoints.up("md")]: {
            position: "fixed",
            top: "unset",
            width: "100%",
          },
        },
      },
    },
    ServicesPage: {
      styleOverrides: {
        root: {
          width: "100%",
        },
        gridContainer: {
          display: "grid",
          gap: theme.spacing(1),
        },
        gridItem: {
          width: "100%",
        },
        emptyDataContainer: {
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: theme.spacing(3),
          marginTop: "calc(50vh - 116px - 64px)", //50vh - emptydata height - header height,
        },
      },
    },
    DirectoryPage: {
      styleOverrides: {
        root: {
          margin: theme.spacing(-1.5, -2, 0),
          scrollMarginTop: "101px",
        },
        filterSection: {
          position: "sticky",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
          top: 101,
          zIndex: 1,
          marginTop: 0,
          paddingTop: theme.spacing(1.5),
          background: theme.palette.background.paper,
          paddingBottom: theme.spacing(0.5),
        },
        categoryFilterBar: {
          gap: theme.spacing(2),
          padding: 0,
          "&.MuiToggleButtonGroup-root": {
            gap: theme.spacing(2),
          },
          "& .MuiToggleButton-root": {
            ":first-of-type": {
              marginLeft: theme.spacing(2),
              [theme.breakpoints.up("md")]: {
                marginLeft: theme.spacing(2),
              },
            },
            ":last-of-type": {
              marginRight: theme.spacing(2),
              [theme.breakpoints.up("md")]: {
                marginRight: theme.spacing(2),
              },
            },
            "& .MuiTypography-root": {
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              wordBreak: "break-word",
              whiteSpace: "normal",
            },
          },
        },
        subCategoryFilterBar: {
          gap: theme.spacing(1.5),
          padding: 0,
          "& .MuiToggleButton-root": {
            borderRadius: "9999px",
            padding: 0,
            height: "unset",
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:first-of-type": {
            borderRadius: "9999px",
            marginLeft: theme.spacing(2),
            border: "1px solid #D6C380",
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:last-of-type": {
            marginRight: theme.spacing(2),
            border: "1px solid #D6C380",
          },
          "& .MuiButtonBase-root.MuiToggleButtonGroup-grouped:not(:first-of-type)":
            {
              borderRadius: "9999px",
              border: "1px solid #D6C380",
            },
        },
        scrollPane: {
          padding: 0,
          "& .MuiToggleButtonGroup-root": {
            gap: theme.spacing(1),
          },
          "& .MuiDivider-root": {
            borderBottomWidth: 8,
          },
        },
        list: {
          padding: theme.spacing(1.5, 2),
          paddingBottom: theme.spacing(1.5),
        },
        emptyDataWrapper: {
          marginTop: "calc(50vh - 116px - 64px)", //50vh - emptydata height - header height,
        },
      },
    },
    EmptyData: {
      styleOverrides: {
        root: {
          width: "100%",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            height: 64,
            width: 64,
            color: "#C6C5C9",
          },
        },
        primaryText: {
          fontWeight: 700,
          color: theme.palette.text.secondary,
        },
        secondaryText: {
          color: theme.palette.text.secondary,
        },
        iconWrapper: {
          marginBottom: 0,
        },
      },
    },
    AppDining: {
      styleOverrides: {
        root: {},
        filterSection: {
          margin: theme.spacing(0, -2),
        },
        filterContainer: {
          padding: 0,
          paddingBottom: theme.spacing(1.5),
        },
        filterButton: {
          gap: theme.spacing(0.5),
          padding: 0,
          "& .MuiToggleButton-root": {
            "& .MuiSvgIcon-root": {
              display: "none",
            },
          },
          "& .MuiToggleButton-root:first-of-type": {
            marginLeft: theme.spacing(2),
            [theme.breakpoints.up("md")]: {
              marginLeft: theme.spacing(2),
            },
          },
          "& .MuiToggleButton-root:last-of-type": {
            marginRight: theme.spacing(2),
            [theme.breakpoints.up("md")]: {
              marginRight: theme.spacing(2),
            },
          },
          whiteSpace: "nowrap",
          "& .MuiSvgIcon-root": {
            marginRight: theme.spacing(1),
          },
        },
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          justifyItems: "center",
          gap: theme.spacing(1.5),
        },
        diningImageCard: {
          display: "block",
          overflow: "hidden",
          aspectRatio: "1 / 1",
          width: "100%",
          height: "100%",
        },
        emptyDataContainer: {
          marginTop: "calc(50vh - 116px - 64px)", //50vh - emptydata height - header height,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "auto",
        },
      },
    },
    EventPage: {
      styleOverrides: {
        root: {},
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gridAutoFlow: "row",
          justifyItems: "center",
          gap: theme.spacing(1.5),
          "&>*": {
            width: "100%",
          },
        },
        emptyDataWrapper: {
          paddingTop: "calc(50vh - 116px - 64px)",
          paddingBottom: 0,
        },
      },
    },
    PromotionPage: {
      styleOverrides: {
        root: {},
        gridContainer: {
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gridAutoFlow: "row",
          justifyItems: "center",
          gap: theme.spacing(1.5),
          "&>*": {
            width: "100%",
          },
        },
        emptyDataWrapper: {
          paddingTop: "calc(50vh - 116px - 64px)",
          paddingBottom: 0,
        },
      },
    },
    VuiDetailCard: {
      styleOverrides: {
        card: {
          backgroundColor: "transparent",
          paddingTop: 0,
        },
        infoListItem: {
          flexDirection: "row",
          "& .MuiListItemText-root": {
            margin: 0,
            "& .MuiListItemText-primary": {
              color: theme.palette.text.primary,
              fontSize: "1rem",
              lineHeight: "1",
              fontWeight: 700,
            },
            "& .MuiListItemText-secondary": {
              fontSize: "0.875rem",
              lineHeight: "1",
              color: theme.palette.text.secondary,
            },
            "& .MuiListItemAvatar-root": {
              minWidth: "52px",
              "& .MuiAvatar-root": {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main,
              },
            },
          },
          "& .MuiListItemAvatar-root": {
            minWidth: "44px",
          },
        },
        infoListItemWithNavigation: {
          padding: 0,
          "& .MuiListItemButton-root": {
            padding: 0,
          },
          marginTop: theme.spacing(1),
          "& .MuiListItemText-root": {
            margin: 0,
            "& .MuiListItemText-primary": {
              color: theme.palette.text.primary,
              fontSize: "1rem",
              lineHeight: "1",
              fontWeight: 700,
            },
            "& .MuiListItemText-secondary": {
              fontSize: "0.875rem",
              lineHeight: "1",
              color: theme.palette.text.secondary,
            },
          },
          "& .MuiListItemAvatar-root": {
            minWidth: "52px",
            "& .MuiAvatar-root": {
              "& .MuiSvgIcon-root": {
                "& svg *": {
                  fill: "#fff",
                  stopColor: "#fff",
                },
              },
              color: theme.palette.primary.contrastText,
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        cardHeader: {
          gap: theme.spacing(1),
          padding: 0,
          paddingBottom: theme.spacing(0.75),
          "& .MuiCardHeader-title": {
            fontWeight: 700,
            fontSize: "1rem",
            lineHeight: "1.1",
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            textOverflow: "ellipsis",
          },
          "& .MuiCardHeader-action": {
            marginRight: 0,
          },
        },
        cardHeaderActionButton: {
          borderRadius: "8px",
          padding: theme.spacing(1),
          width: 40,
          height: 40,
          "& .MuiSvgIcon-root": {
            width: 24,
            height: 24,
            "& path": {
              fill: "#C9C5C6",
            },
          },

          backgroundColor: "transparent",
          border: "1px solid #E4E2E3",
          "&:hover": {
            backgroundColor: "#E4E2E3",
          },
        },
        cardContent: {
          padding: 0,
          paddingTop: theme.spacing(0.5),
        },
        cardContentPrimaryText: {
          color: theme.palette.text.primary,
          fontWeight: 700,
          fontSize: "0.875rem",
          lineHeight: "1",
          marginBottom: theme.spacing(1),
        },
        cardContentSecondaryText: {
          color: theme.palette.text.secondary,
          fontSize: "0.875rem",
          lineHeight: "1.45",
        },
        galleryCarouselWrapper: {
          margin: "0 auto",
          width: "100%",
          [theme.breakpoints.up("sm")]: {
            width: "80%",
          },
          marginBottom: theme.spacing(3),
        },
        galleryCarousel: {
          "& .splide__track": {
            padding: 0,
            margin: 0,
          },
          "& .splide__pagination": {
            position: "absolute",
          },
          [theme.breakpoints.up("sm")]: {
            width: "40%",
            margin: "0 auto",
          },
        },
        galleryCarouselItem: {
          width: "100%",
          objectFit: "cover",
          borderRadius: "12px",
          aspectRatio: "9 / 16",
        },
        cardHeaderAction: {
          display: "flex",
          columnGap: theme.spacing(1),
          marginLeft: theme.spacing(4.75),
        },
        viewLocationContainer: {
          display: "flex",
          margin: theme.spacing(1.5, 0),
          position: "relative",
          padding: 0,
          border: "none",
        },
        viewLocationButton: {
          width: "100%",
          padding: theme.spacing(1.25, 2),
          borderRadius: "12px",
          fontSize: "1rem",
          lineHeight: "1",
          fontWeight: 400,
          background:
            "url(https://s3.venue.in.th/mobile_button_long_0d5b59bab5.png)",
          backgroundSize: "cover",
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(0.8125),
            "& .MuiSvgIcon-root": {
              "& svg *": {
                fill: "#fff",
                stopColor: "#fff",
              },
            },
          },
        },
        scrollTriggerWrapper: {
          position: "fixed",
          bottom: "70px",
          width: "100%",
          padding: theme.spacing(0, 3),
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.grey[200]}`,
          boxShadow: theme.shadows[1],
          display: "block",
        },
      },
    },
    OrdinalSelector: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          width: 48,
          height: 84,
          borderRadius: "100px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: theme.spacing(0.5),
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          cursor: "pointer",
        },
        iconWrapper: {
          backgroundColor: theme.palette.background.default,
          height: 32,
          width: 32,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "9999px",
          color: theme.palette.text.secondary,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiSvgIcon-root": {
            width: 32,
            height: 32,
          },
        },
        floorAvatar: {
          background:
            "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
          width: 40,
          height: 40,
          backgroundSize: "contain",
          borderRadius: "9999px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        dialog: {
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              margin: 0,
              height: "100vh",
              maxHeight: "100vh",
              width: "100vw",
              maxWidth: "100vw",
              borderRadius: 0,
            },
          },
        },
        wrapper: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        },
        closeButton: {
          width: 32,
          height: 32,
          position: "absolute",
          right: "24px",
          "& .MuiSvgIcon-root": {
            width: 32,
            height: 32,
          },
        },
        logoImage: {
          height: 32,
        },
        logoWrapper: {
          height: 32,
          background: theme.palette.background.paper,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flex: 1,
          "&.ics": {
            order: 1,
          },
          "&.iconsiam": {
            order: 2,
          },
        },
        levelText: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 48,
          height: "auto",
          borderBottom: `1px solid ${theme.palette.divider}`,
          position: "relative",
          flex: 1,
          "&.Mui-selected": {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "&.ics": {
              background: theme.palette.primary.main,
            },
          },
          "&.ics": {
            "&.ordinal-1": {
              visibility: "hidden",
            },
            "&.ordinal-2": {
              ":after": {
                content: "''",
                position: "absolute",
                top: 0,
                left: "50vw",
                transform: "translateX(-50%)",
                display: "inline-block",
                background:
                  "url(https://s3.venue.in.th/ordinal_selector_bts_icon_78235bb076.png) center/contain no-repeat",
                width: 142,
                height: "100%",
                zIndex: 1,
              },
            },
          },
          "&.iconsiam": {
            "&.ordinal-8": {
              visibility: "hidden",
            },
          },
          "&.current-location": {
            ":after": {
              content: "''",
              position: "absolute",
              top: 0,
              right: "4px",
              display: "inline-block",
              background:
                "url(https://s3.venue.in.th/ordinal_selector_you_are_here_7ab0f71938.png) center/contain no-repeat",
              width: 70,
              height: 55,
            },
          },
        },
        ordinalContainer: {
          display: "flex",
          overflowY: "auto",
          height: "calc(100vh - 64px)",
        },
        venueOrdinals: {
          flex: 1,
          paddingBottom: 0,
          paddingTop: 0,
          display: "flex",
          flexDirection: "column",
          "&.ics": {
            order: 1,
            background: "#E4E2E070",
          },
          "&.iconsiam": {
            order: 2,
          },
        },
        logoContainer: {
          display: "flex",
          flexDirection: "row",
          borderBottom: "1px solid transparent",
          background:
            "linear-gradient(333deg, #F1EBD5 9.48%, #FCFBF5 69.55%) padding-box, linear-gradient(333deg, #C8AF55 31.92%, #EEE7CC 81.85%) border-box",
          backgroundColor: "transparent",
          marginTop: theme.spacing(4),
        },
      },
    },
    AppMap: {
      styleOverrides: {
        toolbarContainer: {},
        quickLinkContainer: {
          overflowX: "scroll",
          padding: 0,
          display: "flex",
          maxWidth: "100%",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "& .FeatureChipToggleBar-root": {
            paddingBottom: theme.spacing(2.5),
          },
          "& .FeatureChipToggleBar-button": {
            boxShadow:
              "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          },
          [theme.breakpoints.up("md")]: {
            paddingTop: 0,
          },
        },
        navigationContainer: {
          position: "fixed",
          zIndex: theme.zIndex.appBar,
          bottom: 0,
          left: 0,
          right: 0,
        },
        searchBarContainer: {
          padding: theme.spacing(3, 3, 1, 3),
          "& .VuiSearchToggleButton-root": {
            boxShadow:
              "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          },
          [theme.breakpoints.up("md")]: {
            display: "block",
            maxWidth: "350px",
          },
        },
        indoorMapContainer: {
          position: "absolute",
          zIndex: 0,
          width: "100%",
          height: "100%",
          "& > #map": {
            width: "100%",
            height: "100%",
          },
          "& > * > .maptalks-wrapper": {
            transition: "all 500ms ease-out",
            // * Fixing Map transition not working when navigate from Directory to Place Detail.
            WebkitTransition: "-webkit-transform 500ms ease-out",
          },
          "&.bottom-half": {
            overflow: "hidden",
            "& .maptalks-wrapper": {
              transform: `translate(0, 24%)`,
            },
          },
          "&.hidden": {
            opacity: 0,
            visibility: "hidden",
          },
        },
        ordinalSelector: {
          position: "fixed",
          bottom: "185px",
          right: "24px",
          display: "flex",
        },
        locationButtonContainer: {
          display: "none",
        },
        attractionButton: {
          position: "fixed",
          bottom: 84,
          right: 24,
        },
      },
    },
    DiningCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          minHeight: "213px",
          height: "213px",
          width: "166px",
          maxWidth: "166px",
          borderRadius: "8px",
          position: "relative",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          border: "1px solid transparent",
          boxShadow: "none",
        },
        featuredImage: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "none",
          flexDirection: "column",
          position: "relative",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "166px",
            height: "121px",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
          "& .MuiSvgIcon-root": {
            width: 32,
            height: 32,
          },
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: theme.spacing(2.5, 1, 0),
          height: "90px",
        },
        levelAvatar: {
          width: 24,
          height: 24,
          fontSize: "0.75rem",
          fontWeight: 700,
          color: theme.palette.common.white,
          background:
            "url(https://s3.venue.in.th/level_Icon_b460ba199f.svg) , no-repeat",
          backgroundSize: "contain",
          marginRight: theme.spacing(-0.5),
        },
        venueLogo: {
          objectFit: "contain",
          maxHeight: "30px",
          width: "63px",
        },
        titleText: {
          color: theme.palette.text.primary,
          fontSize: "0.825rem",
          lineHeight: 1.3,
          fontWeight: 700,
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          maxHeight: "34px",
        },
        detailWrapper: {
          display: "flex",
          gap: theme.spacing(0.75),
          flexDirection: "column",
        },
        infoContainer: {
          minHeight: "30px",
          height: "30px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 0,
          alignItems: "center",
        },
        logo: {
          width: 36,
          height: 36,
          marginTop: theme.spacing(-5.5),
          borderRadius: "8px",
          border: `2px solid ${theme.palette.common.white}`,
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          "& .MuiAvatar-img": {
            borderRadius: "6px",
          },
        },
        chipContainer: {
          padding: theme.spacing(0.75),
          left: 0,
          right: 0,
          top: 0,
          position: "absolute",
          zIndex: 1,
        },
        chip: {
          width: 32,
          height: 32,
          borderRadius: "100px",
          background:
            "linear-gradient(160.89deg, #8F5F1E -9.16%, #D6A363 26.64%, #C28F4C 42.4%, #734A12 89.43%)",
          "& .MuiChip-label": {
            padding: 0,
            display: "flex",
            alignItems: "center",
          },
          "& .MuiSvgIcon-root": {
            width: 20,
            height: 20,
            fill: "#875541",
          },
        },
        adsChip: {
          marginLeft: "auto",
          "& .MuiChip-label": {
            fontSize: "0.6875rem",
          },
        },
        newShopChip: {
          display: "flex",
          marginLeft: "auto",
          "& .MuiChip-label": {
            fontSize: "0.6875rem",
          },
        },
        comingSoonChip: {
          display: "flex",
          marginLeft: "auto",
          "& .MuiChip-label": {
            fontSize: "0.6875rem",
          },
        },
        vatRefundChip: {
          display: "flex",
          position: "absolute",
          bottom: "4px",
          left: "50px",
          zIndex: 1,
          "& .MuiChip-label": {
            fontSize: "0.6875rem",
          },
        },
        multiLevelContainer: {
          display: "flex",
          marginRight: theme.spacing(-0.5),
          "& > *:first-of-type": {
            borderRadius: "16px 0 0 16px",
            width: 26,
            paddingLeft: theme.spacing(0.25),
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
          "& > *:last-of-type": {
            borderRadius: "0 16px 16px 0",
            width: 26,
            paddingRight: theme.spacing(0.25),
          },
          "& > *:not(:first-of-type):not(:last-of-type)": {
            borderRadius: 0,
            borderRight: `0.4px solid ${theme.palette.divider}`,
          },
        },
        multiLevelAvatar: {
          width: 24,
          height: 24,
          fontSize: "0.7rem",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    PromotionCard: {
      styleOverrides: {
        root: {
          width: "166px",
          minHeight: "391px",
          borderRadius: "8px",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          border: "1px solid transparent",
          boxShadow: "none",
          position: "relative",
        },
        cardMedia: {
          width: "165px",
          height: "294px",
        },
        duration: {
          color: "#948A8D",
          fontSize: "0.75rem",
          margin: 0,
        },
        cardTitle: {
          color: "#56464A",
          fontSize: "0.875rem",
          height: "32px",
          lineHeight: 1.1,
          WebkitLineClamp: 2,
        },
        cardContent: {
          padding: theme.spacing(0.5, 1.5),
          justifyContent: "space-around",
          "&:last-child": {
            paddingBottom: 0,
          },
        },
        cardInfoContainer: {
          height: "17x",
          position: "relative",
          marginTop: 0,
          "& .MuiTypography-root": {
            fontSize: "0.75rem",
            color: "#948A8D",
            width: 80,
            marginLeft: theme.spacing(-0.5),
          },
        },
        venueLogoContainer: {
          display: "flex",
          position: "absolute",
          margin: theme.spacing(1, 1.5),
          bottom: 0,
          right: 0,
          "& .MuiCardMedia-root": {
            maxWidth: "36px",
            maxHeight: "17px",
          },
        },
        iconContainer: {
          "& .MuiSvgIcon-root": {
            height: "18px",
            width: "18px",
            color: theme.palette.primary.main,
            top: 0,
            left: "-4px",
          },
        },
        statusTextContainer: {
          width: "100%",
          backgroundColor: "#EFBB00",
          position: "absolute",
          padding: theme.spacing(0.75),
          bottom: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "24px",
        },
        statusText: {
          fontSize: "0.75rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          padding: theme.spacing(0.5),
          zIndex: 1,
        },
        highlightTextChip: {
          height: "20px",
          display: "flex",
          padding: theme.spacing(0.5, 1),
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          marginRight: "auto",
          background: "#A7A9AC",
        },
        cardContentStack: {
          "&>:not(style)+:not(style)": {
            marginTop: theme.spacing(0.5),
          },
        },
      },
    },
    VerticalEventCard: {
      styleOverrides: {
        root: {
          width: "166px",
          minHeight: "391px",
          borderRadius: "8px",
          background:
            "linear-gradient(180deg, #FFFFFF 71%, #EDEEEE 100%) padding-box, linear-gradient(333deg, #D6C380 30%, #EEE7CC 81.85%) border-box",
          border: "1px solid transparent",
          boxShadow: "none",
          position: "relative",
        },
        cardMedia: {
          width: "165px",
          height: "294px",
        },
        duration: {
          color: "#948A8D",
          fontSize: "0.75rem",
          margin: 0,
        },
        cardTitle: {
          color: "#56464A",
          fontSize: "0.875rem",
          height: "32px",
          lineHeight: 1.1,
          WebkitLineClamp: 2,
        },
        cardContent: {
          padding: theme.spacing(0.5, 1.5),
          justifyContent: "space-around",
          "&:last-child": {
            paddingBottom: 0,
          },
        },
        cardInfoContainer: {
          height: "17x",
          position: "relative",
          marginTop: 0,
          "& .MuiTypography-root": {
            fontSize: "0.75rem",
            color: "#948A8D",
            width: 80,
            marginLeft: theme.spacing(-0.5),
          },
        },
        venueLogoContainer: {
          display: "flex",
          position: "absolute",
          margin: theme.spacing(1, 1.5),
          bottom: 0,
          right: 0,
          "& .MuiCardMedia-root": {
            maxWidth: "36px",
            maxHeight: "17px",
          },
        },
        iconContainer: {
          "& .MuiSvgIcon-root": {
            height: "18px",
            width: "18px",
            color: theme.palette.primary.main,
            top: 0,
            left: "-4px",
          },
        },
        statusTextContainer: {
          width: "100%",
          backgroundColor: "#EFBB00",
          position: "absolute",
          padding: theme.spacing(0.75),
          bottom: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "24px",
        },
        statusText: {
          fontSize: "0.75rem",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          position: "absolute",
          padding: theme.spacing(0.5),
          zIndex: 1,
        },
        highlightTextChip: {
          height: "20px",
          display: "flex",
          padding: theme.spacing(0.5, 1),
          color: theme.palette.primary.contrastText,
          fontWeight: 700,
          marginRight: "auto",
          background: "#A7A9AC",
        },
        cardContentStack: {
          "&>:not(style)+:not(style)": {
            marginTop: theme.spacing(0.5),
          },
        },
      },
    },
    FeatureSummary: {
      styleOverrides: {
        root: {
          display: "grid",
          height: "100%",
          gridTemplateRows: "1fr 84px",
          gridTemplateColumns: "192px minmax(0, 146px)",
          gridGap: theme.spacing(0),
          gridTemplateAreas: `
                  "info info"
                  "logo button"
                `,
          "@media (min-width: 768px)": {
            gridTemplateRows: "1fr 84px 50px",
            gridTemplateColumns: "1fr",
            gridTemplateAreas: "'info' \n 'logo' \n 'button'",
            gridGap: theme.spacing(1.5),
          },
        },
        infoSection: {
          gridArea: "info",
          display: "flex",
          flexDirection: "column",
          minHeight: "58px",
          alignItems: "flex-start",
          gap: theme.spacing(1),
        },
        chipContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: theme.spacing(0.5),
        },
        maintenanceAlert: {
          width: "145px",
          height: "36px",
          backgroundColor: "transparent",
          padding: 0,
          "& .MuiAlert-message": {
            padding: 0,
          },
          "& .MuiChip-root": {
            height: "36px",
            width: "145px",
          },
        },
        title: {
          maxHeight: 45,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          fontSize: "1.125rem",
          lineHeight: 1.2,
          wordBreak: "break-word",
          width: "calc(100% - 42px)",
        },
        container: {
          gridArea: "logo",
          gap: theme.spacing(3),
          display: "flex",
          boxShadow: "none",
        },
        infoContainer: {},
        logoContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 84,
          height: 84,
          borderRadius: "8px",
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`,
        },
        logoImage: {
          height: "100%",
          borderRadius: "8px",
          objectFit: "cover",
        },
        venueLogoContainer: {
          width: 84,
          height: 84,
          borderRadius: 0,
          alignItems: "center",
          padding: theme.spacing(0.5),
        },
        venueLogoImage: {
          width: "100%",
          height: "100%",
          objectFit: "contain",
        },
        locationText: {},
        categoryIcon: {
          width: "36px",
          height: "36px",
        },
        newShopChip: {},
        comingSoonChip: {},
        vatRefundChip: {},
      },
    },
    FeatureActionContainer: {
      styleOverrides: {
        shortInfoActionWrapper: {
          gridArea: "button",
          flexDirection: "column",
          gap: "8px",
          justifySelf: "self-end",
          "&>:not(style)+:not(style)": {
            marginLeft: 0,
          },
          "@media (min-width: 768px)": {
            paddingTop: 0,
            flexDirection: "row",
            justifySelf: "unset",
            paddingLeft: 0,
            paddingBottom: theme.spacing(1.5),
          },
        },
        navigationButton: {
          minWidth: "128px",
          maxWidth: "142px",
          fontSize: "0.875rem",
          fontWeight: 700,
          pointerEvents: "all",
          "@media (max-width:385px)": {
            fontSize: "0.875rem",
          },
          height: "38px",
          padding: theme.spacing(1),
          justifyContent: "center",
          background:
            "url(https://s3.venue.in.th/mobile_button_short_24af4e5dfa.png)",
          backgroundSize: "cover",
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(0.5),
          },
          "@media (min-width: 768px)": {
            minWidth: "unset",
          },
        },
        actionButton: {
          minWidth: "32px",
          width: "32px",
          maxWidth: "32px",
          fontSize: "0.875rem",
          color: theme.palette.text.secondary,
          border: "none",
          pointerEvents: "all",
          "@media (max-width:385px)": {
            fontSize: "0.875rem",
          },
          height: "32px",
          padding: 0,
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          background: "#F3F3F4",
          borderRadius: "9999px",
          right: "16px",
          top: "24px",
          "& .MuiButton-startIcon": {
            margin: 0,
          },
          "&:hover": {
            border: "none",
            color: theme.palette.text.secondary,
            background: "#F3F3F4",
          },
        },
        reservationButton: {
          border: "1px solid #E4E2E3",
          height: 38,
          color: theme.palette.text.primary,
          pointerEvents: "all",
        },
        comingSoonButton: {
          "&.Mui-disabled": {
            color: theme.palette.primary.contrastText,
            fontWeight: 700,
          },
        },
      },
    },
    AppFeatureDetail: {
      defaultProps: {
        productCarouselOptions: {
          perPage: 1,
          fixedWidth: 88,
          fixedHeight: 125,
          gap: 12,
          padding: { left: 12, right: 12 },
        },
      },
      styleOverrides: {
        root: {
          position: "relative",
          overflow: "initial",
          boxShadow: "none",
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1.5),
        },
        listContainer: {
          display: "flex",
          gap: theme.spacing(2),
          alignItems: "flex-start",
          padding: theme.spacing(1.5, 0),
        },
        featureLabel: {
          width: "auto",
          alignItems: "start",
          gap: 0,
          borderRight: "1px solid #E2E2E4",
          paddingRight: theme.spacing(1.5),
          "& .MuiTypography-root:first-of-type": {
            textAlign: "left",
            fontWeight: 400,
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            lineHeight: 1.2,
            textTransform: "capitalize",
          },
          "& .MuiTypography-root:last-of-type": {
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            fontWeight: 700,
            fontSize: "0.875rem",
            lineHeight: 1.2,
            color: theme.palette.text.primary,
          },
        },
        operationTimeLabel: {
          alignItems: "start",
          minWidth: "94px",
          gap: 0,
          "& .MuiTypography-root:first-of-type": {
            textAlign: "left",
            fontWeight: 400,
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            lineHeight: 1.2,
            textTransform: "capitalize",
          },
          "& .MuiTypography-root:last-of-type": {
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1.2,
            WebkitBoxOrient: "vertical",
            fontWeight: 700,
            fontSize: "0.875rem",
            lineHeight: 1.2,
            color: theme.palette.text.primary,
          },
        },
        openingLabel: {
          alignItems: "start",
          minWidth: "94px",
          gap: 0,
          "& .MuiTypography-root:first-of-type": {
            textAlign: "left",
            fontWeight: 400,
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            lineHeight: 1.2,
            textTransform: "capitalize",
          },
          "& .MuiTypography-root:last-of-type": {
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            fontWeight: 700,
            fontSize: "0.875rem",
            lineHeight: 1.2,
            color: theme.palette.error.main,
          },
        },
        section: {
          margin: theme.spacing(0),
          "&:first-of-type": {
            marginTop: 0,
          },
          "& .splide": {
            "& .splide__track": {
              margin: theme.spacing(-1.5),
              padding: 0,
              paddingTop: theme.spacing(1.5),
              paddingBottom: theme.spacing(1.5),
            },
          },
        },
        galleryImage: {
          objectFit: "cover",
          display: "block",
          cursor: "pointer",
          width: "180px",
          height: "120px",
          borderRadius: "4px",
          boxShadow: "none",
        },
        divider: {
          borderBottom: `1px solid #E4E2E3`,
          marginLeft: 0,
          marginRight: 0,
        },
        descriptionText: {
          color: theme.palette.text.primary,
        },
        contactButton: {
          textTransform: "lowercase",
          display: "flex",
          padding: theme.spacing(1),
          color: theme.palette.text.primary,
          fontSize: "0.875rem",
          fontWeight: 400,
          lineHeight: 1.1,
          "& .MuiSvgIcon-root": {
            color: theme.palette.primary.main,
          },
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(1),
          },
        },
        contactWrapper: {},
        sectionTitle: {
          display: "flex",
          fontSize: theme.typography.subtitle1.fontSize,
          fontWeight: theme.typography.fontWeightBold,
          marginBottom: 0,
          color: theme.palette.text.primary,
        },
        productImage: {
          width: 88,
          height: 88,
          objectFit: "cover",
          borderRadius: "4px",
        },
        productName: {
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          color: theme.palette.text.primary,
          margin: theme.spacing(0.5),
          lineHeight: 1.2,
          fontWeight: 400,
        },
      },
    },
    ReservationPage: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0,
          height: 64,
        },
        listItemButton: {
          padding: theme.spacing(1.5, 0),
        },
        listItemAvatar: {
          minWidth: 40,
          width: 40,
          height: 40,
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          marginRight: theme.spacing(2),
          "& .MuiAvatar-root": {
            borderRadius: "8px",
          },
          "& .MuiSvgIcon-root": {
            color: "#C6C5C9",
          },
        },
        text: {
          flexGrow: 1,
          fontWeight: 700,
          color: theme.palette.text.primary,
        },
        icon: {
          color: theme.palette.text.secondary,
          width: 20,
          height: 20,
        },
        dialogContent: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: theme.spacing(1.5),
        },
        dialog: {
          "& .MuiDialog-paper": {
            width: "100%",
            height: 222,
            overflow: "visible",
          },
        },
        closeButton: {
          position: "absolute",
          background: "#F3F3F4",
          top: "-12px",
          right: "-12px",
          width: 32,
          height: 32,
          color: theme.palette.text.secondary,
          "& .MuiSvgIcon-root": {
            width: 18,
            height: 18,
          },
        },
        dialogPrimaryText: {
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
        buttonWrapper: {
          display: "flex",
          justifyContent: "center",
          flexGrow: 1,
          alignItems: "center",
        },
        phoneIcon: {
          color: theme.palette.text.primary,
        },
        phoneButton: {
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(0.5),
          },
          color: theme.palette.text.primary,
          fontSize: "1rem",
        },
      },
    },
    ServiceDetailPage: {
      styleOverrides: {
        root: {},
        list: {
          paddingTop: 0,
        },
        locationListItem: {
          height: 64,
          borderBottom: "1px solid #E2E2E4",
          padding: theme.spacing(1.5, 1.5, 1.5, 0),
          gap: theme.spacing(2),
          display: "flex",
          "&.ServiceCard-locationListItem--highlight": {
            border: "1px solid #C8AF55",
            background:
              "linear-gradient(333deg, rgba(200, 175, 85, 0.40) 31.92%, rgba(238, 231, 204, 0.40) 81.85%)",
            height: 38,
            borderRadius: "4px",
            padding: theme.spacing(0.5, 0.5, 0.5, 1.5),
            marginBottom: theme.spacing(1),
            color: theme.palette.primary.main,
          },
        },
        locationNavigateButton: {
          color: theme.palette.primary.main,
        },
        venueLogoWrapper: {
          width: 80,
          height: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        venueLogo: {
          maxWidth: 64,
          maxHeight: 30,
          objectFit: "contain",
        },
        locationLogoWrapper: {},
        locationLogo: {
          width: 40,
          height: 40,
          borderRadius: "8px",
        },
        listNameText: {
          flexGrow: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          fontWeight: 700,
        },
        floorTextAvatar: {
          background:
            "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
          width: 32,
          height: 32,
          backgroundSize: "contain",
          borderRadius: "9999px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: 700,
          color: theme.palette.primary.contrastText,
          minWidth: 32,
          fontSize: "0.875rem",
        },
        emptyDataContainer: {
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: theme.spacing(3),
          marginTop: "calc(50vh - 116px - 64px)", //50vh - emptydata height - header height,
        },
      },
    },
    LuxuryCard: {
      styleOverrides: {
        root: {
          width: 166,
          height: 206,
          borderRadius: "4px",
          position: "relative",
          boxShadow:
            "0px 34px 9px 0px rgba(0, 0, 0, 0.00), 0px 22px 9px 0px rgba(0, 0, 0, 0.01), 0px 12px 7px 0px rgba(0, 0, 0, 0.03), 0px 5px 5px 0px rgba(0, 0, 0, 0.05), 0px 1px 3px 0px rgba(0, 0, 0, 0.06)",
          border: `1px solid ${theme.palette.divider}`,
          "&.with-logo": {
            "&:before": {
              content: '""',
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              background:
                "linear-gradient(180deg, rgba(0, 0, 0, 0.1) 31.48%, rgba(0, 0, 0, 0.84) 95.03%)",
              borderRadius: "4px",
            },
          },
        },
        cardMedia: {
          height: "100%",
          width: "100%",
        },
        logo: {
          zIndex: 1,
          height: "100%",
          width: "100%",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: 133,
          maxHeight: 124,
          filter: "grayscale(1) invert(50%) brightness(2)",
          backgroundSize: "contain",
        },
      },
    },
    AppDirectionOverview: {
      defaultProps: {
        maxLocationName: 25,
        drawer: { drawerBleeding: 158 },
      },
      styleOverrides: {
        root: {},
        primaryText: {
          marginBottom: theme.spacing(1),
        },
        secondaryText: {
          fontWeight: 400,
          fontSize: "0.875rem",
        },
        drawer: {},
        bleedWrapper: {
          padding: theme.spacing(3.5, 2, 3),
          "button, a": { pointerEvents: "all" },
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        stepper: {
          "& .MuiStep-vertical": {
            ":not(:last-of-type)": {
              "& .MuiStepLabel-labelContainer": {
                borderBottom: `1px solid ${theme.palette.divider}`,
              },
            },
            "& .MuiStepLabel-labelContainer": {
              padding: theme.spacing(2.25, 0),
            },
          },
        },
        stepOverviewContainer: {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
          "button, a": { pointerEvents: "all" },
        },
        directionSummaryContainer: {
          [theme.breakpoints.down("sm")]: {
            height: 52,
          },
        },
        locationText: {
          fontWeight: 400,
          color: theme.palette.text.secondary,
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          minWidth: 0,
        },
        ordinalSelector: {
          "& .OrdinalSelector-root": {
            left: "unset",
            right: theme.spacing(2),
            bottom: theme.spacing(21.5),
            marginRight: 0,
            padding: theme.spacing(0.5),
            "& .MuiList-root": {
              flexDirection: "column-reverse",
              "& .MuiButtonBase-root": {
                width: 40,
                height: 40,
                minHeight: 40,
                border: "1px solid #E2E2E4",
                color: theme.palette.text.secondary,
                fontSize: "1rem",
                "&.Mui-selected": {
                  background:
                    "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
                  backgroundSize: "contain",
                  border: "none",
                  color: "#FFF",
                  fontWeight: 700,
                },
              },
            },
          },
        },
        connector: {
          display: "flex",
          marginTop: theme.spacing(-3),
          marginLeft: theme.spacing(2.25),
          height: 48,
          marginBottom: theme.spacing(-3),
          "& .MuiStepConnector-line": {
            borderLeftStyle: "dotted",
            borderLeftWidth: "4px",
            borderColor: "#C6C5C9",
          },
        },
        highlightedText: {
          fontWeight: 400,
          fontSize: "0.875rem",
        },
      },
    },
    DirectionStep: {
      styleOverrides: {
        originIcon: {
          fill: theme.palette.primary.main,
          width: 40,
          height: 40,
          "& .highlight": {
            fill: theme.palette.primary.main,
            opacity: 0.3,
          },
          "& .highlight-border": {
            fill: theme.palette.primary.main,
          },
          "& .highlight-center-point": {
            fill: theme.palette.primary.main,
          },
        },
        destinationIcon: {
          fill: theme.palette.error.main,
          width: 40,
          height: 40,
        },
        highlightedText: {
          color: theme.palette.text.primary,
          textAlign: "inherit",
          lineHeight: "inherit",
          fontSize: "0.875rem",
          fontWeight: 700,
        },
        directionStepIcon: {
          fill: theme.palette.primary.contrastText,
          height: 28,
          width: 28,
          background: "#C6C5C9",
          padding: theme.spacing(0.75),
          borderRadius: "9999px",
          margin: theme.spacing(0.75),
        },
      },
    },
    SuggestionListItem: {
      defaultProps: {},
      styleOverrides: {
        root: {},
        newShopChip: {
          height: 16,
          padding: theme.spacing(0.25, 1),
          width: 50,
        },
      },
    },
    AppNavigationStep: {
      styleOverrides: {
        wrapper: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        container: {
          position: "fixed",
          bottom: 0,
          zIndex: theme.zIndex.modal,
          display: "flex",
          right: 0,
          left: 0,
          background: theme.palette.background.paper,
          padding: theme.spacing(2, 3),
          flexDirection: "column",
          height: 256,
          marginLeft: 0,
          marginRight: 0,
          borderRadius: "32px 32px 0px 0px",
          [theme.breakpoints.up("sm")]: {
            maxWidth: 565,
            margin: "auto",
          },
        },
        title: {
          fontSize: "1rem",
          fontWeight: "bold",
        },
        primaryText: {
          color: theme.palette.text.primary,
          textAlign: "center",
          fontWeight: 400,
          lineHeight: 1.5,
        },
        highlightedText: {
          color: theme.palette.text.primary,
          textAlign: "inherit",
          fontWeight: "inherit",
          lineHeight: "inherit",
          fontSize: "inherit",
        },
        locationText: {
          color: theme.palette.text.primary,
          fontSize: "0.75rem",
          lineHeight: 1.1,
          fontWeight: 700,
          textTransform: "uppercase",
          textAlign: "center",
          marginTop: theme.spacing(1),
          width: 72,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        },
        headerWrapper: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          color: theme.palette.common.black,
          fontSize: theme.typography.caption.fontSize,
          "& .MuiIconButton-root": {
            fontSize: "inherit",
          },
        },
        stepTextContainer: {
          height: "40px",
          display: "flex",
          alignItems: "center",
        },
        overviewWrapper: {
          justifyContent: "space-between",
          flexDirection: "row",
        },
        playerControls: {
          display: "inline-flex",
          position: "absolute",
          top: 0,
          right: 0,
          margin: theme.spacing(2, 3),
        },
        iconNavButton: {
          display: "block",
          padding: 0,
          background: "#F3F3F4",
          width: 32,
          height: 32,
          "&:hover": {
            background: "#F3F3F4",
          },
          "& .MuiSvgIcon-root": {
            color: theme.palette.text.secondary,
            width: 16,
            height: 16,
          },
          "&.Mui-disabled": {
            background: "#F8F8FF",
            "& .MuiSvgIcon-root": {
              color: "#E2E2E4",
            },
          },
        },
        stepProgressBar: {
          display: "block",
          padding: theme.spacing(3, 2, 1.5),
        },
        stepDetailStack: {
          gap: theme.spacing(0),
        },
        venueLogowrapper: {
          display: "flex",
          height: 32,
          width: 72,
          justifyContent: "center",
          alignItems: "center",
          background: "#F4F3F3",
          borderRadius: "32px",
          "& .MuiCardMedia-root": {
            height: 15,
            width: 55,
            backgroundSize: "contain",
          },
        },
        cooldownProgress: {
          display: "inline-block",
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
    },
    AppTopBar: {
      styleOverrides: {
        root: {
          padding: theme.spacing(4, 2),
          top: 0,
          position: "absolute",
          width: "fit-content",
          left: 0,
          right: 0,
          zIndex: theme.zIndex.modal,
        },
        ordinalSelector: {
          position: "static",
          "& .OrdinalSelector-root": {
            left: "unset",
            right: 16,
            bottom: 267,
            marginRight: 0,
            padding: theme.spacing(0.5),
            width: 48,
            height: 48,
            boxShadow:
              "1px 1px 4px 0px #00000012,5px 6px 8px 0px #0000000F,12px 13px 11px 0px #0000000A,21px 23px 13px 0px #00000003,33px 36px 14px 0px #00000000",
            border: `1px solid #ececec`,
            backgroundColor: theme.palette.background.paper,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          "& .OrdinalSelector-list": {
            borderRadius: 9999,
            width: "40px",
            height: "40px",
            padding: 0,
            backgroundColor: theme.palette.background.paper,
            marginTop: 0,
          },
          "& .OrdinalSelector-label": {
            display: "none",
          },
          "& .OrdinalSelector-button": {
            height: 40,
            width: 40,
            fontWeight: 700,
            padding: 0,
            minHeight: 40,
            background:
              "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
            backgroundSize: "contain",
            fontSize: "1rem",
          },
        },
        backButton: {
          color: theme.palette.text.secondary,
          width: "48px",
          height: "48px",
          padding: theme.spacing(1.5),
        },
      },
    },
    AttractionButton: {
      styleOverrides: {
        root: {
          width: 88,
          height: 88,
          position: "relative",
          cursor: "pointer",
        },
        carousel: {
          width: 88,
          height: 88,
          borderRadius: "50%",
          overflow: "hidden",
          border: "1px solid transparent",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          background:
            "linear-gradient(180deg, #FFFFFF 38.03%, #EDEEEE 100%, #FFF) padding-box, linear-gradient(333deg, #C8AF55 31.92%, #EEE7CC 81.85%) border-box",
          "& .splide": {
            height: "100%",
          },
          "& .splide__track": {
            height: "100%",
            padding: theme.spacing(0.5),
            margin: 0,
          },
          "&:after": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: theme.spacing(0.625),
            borderRadius: "50%",
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.1) 46.17%, rgba(0, 0, 0, 0.84) 85.67%)",
            pointerEvents: "none",
          },
        },
        carouselItem: {
          width: "100%",
          height: "100%",
          borderRadius: "50%",
        },
        image: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "50%",
        },
        attractionText: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: theme.palette.secondary.contrastText,
          fontWeight: 700,
          fontSize: "0.75rem",
          zIndex: 10,
          padding: theme.spacing(0.5, 1.5),
          borderRadius: "16px",
          textShadow: "1px 1px 4px rgba(0,0,0,0.8)",
          pointerEvents: "none",
        },
      },
    },
    ComingSoonChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: "#EFBB00",
          textTransform: "uppercase",
          "& .MuiChip-label": {
            padding: theme.spacing(0),
            fontSize: "0.75rem",
            fontWeight: 400,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    NewShopChip: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5, 1),
          height: "20px",
          borderRadius: "24px",
          backgroundColor: "#F03D3D",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.75rem",
            fontWeight: 400,
            color: theme.palette.primary.contrastText,
            textTransform: "capitalize",
          },
        },
      },
    },
    VatRefundChip: {
      styleOverrides: {
        root: {
          background:
            "linear-gradient(89.59deg, #0ED065 54.18%, rgba(14, 208, 101, 0) 100%)",
          padding: theme.spacing(0.25, 1, 0.25, 1),
          width: "98px",
          height: "20px",
          borderRadius: 0,
          justifyContent: "flex-start",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.625rem",
            fontWeight: 400,
            color: theme.palette.common.white,
          },
        },
      },
    },
    DirectionSearchContainer: {
      styleOverrides: {
        wrapper: {
          width: "100%",
          [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
          },
        },
        suggestionList: {
          marginTop: theme.spacing(8),
          // direction search box = 108 px
          // avoid step button 32 px + top-bottom margin 16px * 2 = 64px
          // top-bottom page layout padding 24px * 2 = 48px
          maxHeight: `calc(100vh - 220px)`,
          overflow: "auto",
          background: theme.palette.background.paper,
          boxShadow: theme.shadows[1],
          position: "absolute",
          zIndex: theme.zIndex.drawer + 1,
          borderRadius: "10px",
          //left-right layout padding = 24 * 2 = 48px
          width: `calc(100vw - 48px)`,
          [theme.breakpoints.up("sm")]: {
            //left-right layout padding = 24 * 2 = 48px
            maxWidth: 332,
          },
        },
      },
    },
    UserLocationListItem: {
      styleOverrides: {
        icon: {
          background: "transparent",
          color: theme.palette.text.primary,
          fontSize: "3rem",
          "& .MuiSvgIcon-root": {
            fontSize: "inherit",
          },
        },
      },
    },
    FloorSelectionPanel: {
      styleOverrides: {
        root: {
          position: "fixed",
          right: "16px",
          bottom: "172px",
          width: "48px",
          transform: "translateY(-50%)",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.paper,
          borderRadius: "64px",
          boxShadow:
            "33px 36px 14px 0px rgba(0, 0, 0, 0.00), 21px 23px 13px 0px rgba(0, 0, 0, 0.01), 12px 13px 11px 0px rgba(0, 0, 0, 0.04), 5px 6px 8px 0px rgba(0, 0, 0, 0.06), 1px 1px 4px 0px rgba(0, 0, 0, 0.07)",
          "@media (min-width: 767px)": {
            left: "16px",
            bottom: "50%",
            width: "76px",
          },
        },
        buttonWrapper: {
          flexDirection: "column",
          padding: theme.spacing(0.5),
          gap: theme.spacing(0.5),
          "& .MuiToggleButtonGroup-grouped": {
            borderRadius: "50%",
            "&:not(:first-of-type)": {
              borderRadius: "50%",
              margin: 0,
              border: `1px solid ${theme.palette.divider}`,
            },
            "&:first-of-type": {
              borderRadius: "50%",
              margin: 0,
              border: `1px solid ${theme.palette.divider}`,
            },
          },
          "@media (min-width: 767px)": {
            padding: theme.spacing(1),
            gap: theme.spacing(1),
          },
        },
        floorButton: {
          width: 40,
          height: 40,
          borderRadius: "50%",
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
          padding: 0,
          margin: 0,
          "&.Mui-selected": {
            background:
              "url(https://s3.venue.in.th/ordinal_button_pattern_9027ebd907.svg)",
            color: theme.palette.primary.contrastText,
            border: `2px solid ${theme.palette.primary.main}`,
            backgroundSize: "contain",
          },
          "@media (min-width: 767px)": {
            width: 56,
            height: 56,
          },
        },
        floorText: {
          fontSize: "1rem",
          fontWeight: 700,
          lineHeight: 1,
          "@media (min-width: 767px)": {
            fontSize: "1.25rem",
          },
        },
      },
    },
  },
})
